RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const View = RivalIQ.channels.views.DismissableView.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        className: 'ads-upsell panel panel-default x-channel-wall callout callout-info text-center',
        template: '#fbInsightsTokenRequestTemplate'
    });

    const SmallAdsUpsellView = RivalIQ.channels.views.DismissableView.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        className: 'callout text-center',

        template: '#fbInsightsTokenRequestTemplate'
    });

    const Widget = RivalIQ.apps.Dashboard.widgets.TokenRequestWidget.extend({
        filter: function () {
            const me = this;

            const boostedPosts = RivalIQ.state.account.channelDisplay(RivalIQ.enums.sourceMask.FACEBOOK_BOOSTED_POST_INSIGHTS);
            if (!boostedPosts) {
                return true;
            }

            if (me.isDismissed()) {
                return true;
            }

            // if we don't have the user's token, we're going to show another widget to ask them for it.
            if (!me.haveUserToken()) {
                return true;
            }

            const presence = me.curation.presence;
            // if any of the tokens has ads_read, then we're good.
            // TODO: wait, what if some other user gave us ads_read but not the current user? Their token might see different ad accounts.
            return _.get(presence.get('sources'), [RivalIQ.enums.sources.FACEBOOK_BOOSTED_POST_INSIGHTS, 'validToken'], false);
        },

        panelView: View
    });

    widgets.SmallAdsUpsellWidget = Widget.extend({
        view: SmallAdsUpsellView
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_ADS_TOKEN_REQUEST, Widget);

});
